<template>
  <div v-if="data.length">
    <van-row v-for="(item, index) in data" :key="index" type="flex" class="order-box" align="center">
      <van-col :span="12" class="border-right pt30 pb30 pl20">
        <van-row type="flex" align="center">
          <van-col>
            <van-image
              :src="_getPic(item.AfterSaleReturnGoods.length > 0 ? item.AfterSaleReturnGoods[0].Logo : '', true)"
              :class="{ zengsong: item.AfterSaleReturnGoods.length > 0 ? item.AfterSaleReturnGoods[0].IsGift : '' }"
              fit="scale-down"
              width="100px"
              height="100px"
            />
          </van-col>
          <van-col class="pl10">
            <van-cell :value="`订单编号：  ${item.AfterSaleNo}`" value-class=" f14 c777" :border="false" />
            <van-cell :value="`下单时间：  ${item.CreateTime}`" value-class="f14 c777" :border="false" />
            <van-cell value-class="f14 c777" :border="false">
              <template>
                订单内共
                <span class="c0F6EE9">{{ getProductsCount(item) }}</span>
                盒商品
              </template>
            </van-cell>
          </van-col>
        </van-row>
      </van-col>
      <van-col :span="12">
        <van-row type="flex" align="center">
          <van-col :span="8" class="border-right">
            <div class="f16 c222">
              ￥
              <span>{{ _getPriceArray(Number(item.TotalRefundAmount).toFixed(2))[0] }}</span>
              .{{ _getPriceArray(Number(item.TotalRefundAmount).toFixed(2))[1] }}
            </div>
            <div class="mt14 	c222 f12 border-top">{{ item.PayMode }}</div>
          </van-col>
          <van-col :span="8" class="border-right">
            <div class="c222 f16 fw400" :style="{color:item.RefundSatete===4?'#FF3939':'#222'}">{{ item.RefundSatetesName }}</div>
          </van-col>
          <van-col :span="8" class="border-right">
            <div>
              <div class="mb6" @click="() => goOrderDetails(item.Id)"><a href="javascript:void(0)" class="c999 f12 ihover">查看详情</a></div>
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base.js'
import { BaseMixin } from '../mixins/BaseMixin.js'

export default {
  name: 'IOrderListRefund',
  mixins: [BaseMixin],
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      IsOrder: false,
      Info: null
    }
  },
  mounted() {
    this.IsOrder = this.$auth.getCustomerOtherInfo().IsOrder
  },
  methods: {
    // 计算包含商品盒数
    getProductsCount(item) {
      let Count = 0
      if (item.AfterSaleReturnGoods.length !== 0 && item.AfterSaleReturnGoods !== null) {
        Count = Number(item.AfterSaleReturnGoods.length)
      }
      return Count
    },
    // 订单详情
    goOrderDetails(id) {
      this.$emit('goDetails', id)
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/styles/confirmOrder.less');

.order-box {
  margin-bottom: 22px;
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 2px;

  &:last-child {
    margin-bottom: 0;
  }

  .border-right {
    display: flex;
    justify-content: center;
    border-right: 1px solid #E8E8E8;
    height: 164px;
    flex-direction: column;

    &:last-child {
      border: 0;
    }

    .mb6 {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .border-top {
      position: relative;

      &::after {
        position: absolute;
        top: -7px;
        left: 50%;
        width: 139px;
        height: 1px;
        background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 20%, #E0E0E0 50%, #FFFFFF 80%, #FFFFFF 100%);
        content: '';
        transform: translateX(-50%);
      }
    }
  }

  .mt14 {
    margin-top: 14px;
  }
}

.van-cell {
  padding: 0;
}

.payBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  background: rgba(255, 57, 57, 1);
  line-height: 34px;
}

.plainPayBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 57, 57, 1);
  line-height: 34px;
}

.plainBtn {
  border: 1px solid #0F6EE9;
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: #0F6EE9;
  line-height: 34px;
}

/deep/ .van-cell:not(:last-child)::after {
  border-bottom: 0;
}

/deep/ .zengsong.van-image {
  position: relative;

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 30px;
    font-size: 10px;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 57, 57, .6);
    line-height: 30px;
  }
}

.wrapper {
  margin: 5% auto 0;
  width: 900px;
}
</style>
